import { render } from "./MicroProductCard.vue?vue&type=template&id=7c587920&scoped=true"
import script from "./MicroProductCard.vue?vue&type=script&lang=js"
export * from "./MicroProductCard.vue?vue&type=script&lang=js"

import "./MicroProductCard.vue?vue&type=style&index=0&id=7c587920&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c587920"]])

export default __exports__